<template>
  <div class="mx-4 mb-4">
    <div class="mb-3 mt-4" style="position:relative;">
      <span class="main-title">RIDER SUMMARY | &nbsp;</span>
      <span class="submain-title">Rider report</span>
      <download-excel
        :data="export_rider_format"
        :fields="{
            'No':  'No' ,
            'Rider status': 'status' ,
            'Rider name' : 'rider_name'   ,
            'Start date':  'rider_time_start'  ,
            'tel.' : 'rider_tel' ,
            'Service Food/Mes/Free' : 'serviceFoodMesFree'  ,
            'Revenue' : 'revenue' ,
            'Com. 20%' : 'com' ,
            'Net revenus' : 'net_revenue'  ,
            'Credit' : 'credit'  ,
            'Tax com' : 'tax_com',
           }"
        :name="'RiderReport_'+search_config.datetime_start+'_to_'+search_config.datetime_end+'.xls'"
        style="position:absolute;top:0px;right:40px;"
      >
        <v-btn icon>
          <v-icon large color="black">print</v-icon>.xls
        </v-btn>
      </download-excel>
      <download-excel
        type="csv"
        :data="export_rider_format"
        :fields="{
            'No':  'No' ,
            'Rider status': 'status' ,
            'Rider name' : 'rider_name'   ,
            'Start date':  'rider_time_start'  ,
            'tel.' : 'rider_tel' ,
            'Service Food/Mes/Free' : 'serviceFoodMesFree'  ,
            'Revenue' : 'revenue' ,
            'Com. 20%' : 'com' ,
            'Net revenus' : 'net_revenue'  ,
            'Credit' : 'credit'  ,
            'Tax com' : 'tax_com',
           }"
        :name="'RiderReport_'+search_config.datetime_start+'_to_'+search_config.datetime_end+'.csv'"
        style="position:absolute;top:0px;right:150px;"
      >
        <v-btn icon>
          <v-icon large color="black">print</v-icon>.csv
        </v-btn>
      </download-excel>
    </div>
    <searchRiderReport />
    <riderReportList />
  </div>
</template>

<script>
import { mapState } from "vuex";
import searchRiderReport from "@/components/back-office/Report/SearchBar/SearchRiderReport";
import riderReportList from "@/components/back-office/Report/RiderReportList";
export default {
  data() {
    return {};
  },
  destroyed() {
    this.$store.commit("fetchRiderReport/resetState");
  },
  components: {
    searchRiderReport,
    riderReportList
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/"
      },
      {
        text: "Select service",
        disabled: false,
        href: "/weserve_admin_login/control/" + this.$route.params.province
      },
      {
        text: "Dashboard report",
        disabled: false,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/report/main_dashboard"
      },
      {
        text: "Rider report",
        disabled: true,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/report/rider_report"
      }
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  },
  computed: {
    ...mapState({
      search_config: state => state.fetchRiderReport.clone_config_path,
      export_rider_format: state => state.fetchRiderReport.export_rider_format
    })
  }
};
</script>

<style scoped>
.main-title {
  font-size: 22px;
  font-weight: bold;
}
.submain-title {
  font-size: 20px;
  color: #707070;
}
</style>
